import { Text } from "@aurem/ui";
import { ReactNode } from "react";

type Props = {
  title: string;
  children?: ReactNode;
};

export const ControlsSection = ({ title, children }: Props) => {
  return (
    <div>
      <Text className="p-4 text-neutral-500/50" size="sm">
        {title}
      </Text>
      <div className="grid grid-cols-1 p-2 pt-0">{children}</div>
    </div>
  );
};
